if (!customElements.get("f-cart-goal")) {
  class FCartGoal extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        cartDrawer: ".f-cart-drawer__inner",
        leftToSpend: "[data-left-to-spend]",
      };
      this.confettiShow = false;
      this.goalDone = false;
      const rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1);
      this.goal = Number(this.dataset.cartGoal) * rate || 0;
      this.money_format = (window.FoxThemeSettings && window.FoxThemeSettings.money_format) || "${{amount}}";
      this.enableConfetti = this.dataset.enableConfetti === "true";
    }

    connectedCallback() {
      this.updateCartGoal(Number(this.dataset.cartTotal) || 0);
      if (window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== "undefined") {
        window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, async (state) => {
          if (state && typeof state.items_subtotal_price === "number") {
            this.updateCartGoal(state.items_subtotal_price);
          }
          try {
            const newCart = window.FoxThemeCartHelpers ? await window.FoxThemeCartHelpers.getState() : null;
            if (newCart) this.updateCartGoal(newCart.items_subtotal_price);
          } catch (e) {}
        });
      }
      this.confettiShow = this.goalDone;
    }

    formatLeft(cents) {
      try {
        if (typeof formatMoney === "function") return formatMoney(cents, this.money_format);
      } catch (e) {}
      return "$" + (cents / 100).toFixed(2);
    }

    updateCartGoal(subtotalCents) {
      if (!this.goal) return;
      this.classList.toggle("hidden", !(subtotalCents > 0));

      const total = subtotalCents / 100;
      const left = Math.max(this.goal - total, 0);
      const percent = Math.min((total * 100) / this.goal, 100);
      this.goalDone = left <= 0;

      this.style.setProperty("--progress", percent + "%");
      this.dataset.total = total;
      this.classList.toggle("f-cartgoal--done", this.goalDone);

      const leftEl = this.querySelector(this.selectors.leftToSpend);
      if (leftEl && !this.goalDone) leftEl.innerHTML = this.formatLeft(Math.round(left * 100));

      if (this.goalDone && this.enableConfetti) {
        this.showConfetti();
      } else {
        this.confettiShow = false;
      }
    }

    showConfetti() {
      const cartDrawer = this.closest(this.selectors.cartDrawer);
      const cartTemplate = this.closest(".cart-template");
      if (!this.confettiShow && (cartDrawer || cartTemplate) && window.FoxTheme && window.FoxTheme.Confetti) {
        setTimeout(() => {
          if (cartDrawer) new window.FoxTheme.Confetti(cartDrawer);
          if (cartTemplate) new window.FoxTheme.Confetti(document.body);
          this.confettiShow = true;
        }, 800);
      }
    }
  }

  customElements.define("f-cart-goal", FCartGoal);
}
